import { render, staticRenderFns } from "./RootNodeConfig.vue?vue&type=template&id=353db6b1&scoped=true&"
import script from "./RootNodeConfig.vue?vue&type=script&lang=js&"
export * from "./RootNodeConfig.vue?vue&type=script&lang=js&"
import style0 from "./RootNodeConfig.vue?vue&type=style&index=0&id=353db6b1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "353db6b1",
  null
  
)

export default component.exports